export const RightIcon = () => {
  return (
    <svg width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6 5.5L0 10.2631V0.73686L6 5.5Z" fill="#1E1E1E" />
    </svg>
  );
};
